import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { space10 } = theme();

  return StyleSheet.create({
    buttonIconPlaceholder: {
      flexGrow: 0,
      height: space10,
      width: space10,
    },
  });
};

export { style };
